import { cva } from "class-variance-authority";

export const stepContainer = cva(
  "w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all text-left",
  {
    variants: {
      state: {
        active: "bg-white  -prime-700 ",
        completed: " bg-gray-50",
        pending: "bg-gray-50  -transparent",
        success: "bg-green-50  -green-500 shadow-md",
        hover: "hover:bg-gray-100 hover:shadow-sm", // Only applies if not active/success? Original code applied hover to all.
      },
      isHoverable: {
        true: "hover:bg-gray-100 hover:shadow-sm cursor-pointer",
        false: "",
      },
    },
    defaultVariants: {
      state: "pending",
      isHoverable: false,
    },
  }
);

export const stepNumber = cva(
  "flex-shrink-0 w-7 h-7 rounded-full border flex items-center justify-center text-sm font-semibold transition-colors",
  {
    variants: {
      state: {
        active: "border-prime-700 text-prime-700",
        completed: "text-green-500",
        pending: " bg-gray-200 text-gray-600",
        success: " bg-green-500 text-black",
      },
    },
    defaultVariants: {
      state: "pending",
    },
  }
);

export const stepLabel = cva("text-sm font-medium font-sans flex-shrink-0", {
  variants: {
    state: {
      active: "text-gray-900 font-semibold",
      completed: "text-gray-600",
      pending: "text-gray-700",
      success: "text-green-900",
    },
  },
  defaultVariants: {
    state: "pending",
  },
});

export const stepValue = cva(
  "text-sm font-semibold font-serif ml-4 text-right truncate",
  {
    variants: {
      state: {
        active: "text-gray-900",
        completed: "text-gray-600",
        pending: "text-gray-400 italic",
        success: "text-green-900",
      },
      hasValue: {
        true: "",
        false: "text-gray-400 italic",
      },
    },
    compoundVariants: [
      {
        state: ["active", "completed", "success"],
        hasValue: false,
        class: "text-gray-400 italic", // Ensure placeholder style if no value
      },
    ],
    defaultVariants: {
      state: "pending",
      hasValue: false,
    },
  }
);
